import axios from 'axios';
import { getNavigate } from './NavigateHelper';
import { getSafeInternalPath } from './safeRedirect';

const mernDashApi = axios.create({});

mernDashApi.interceptors.request.use(function (config) {
  const token = localStorage.getItem('mern_admin_dashboard');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

function buildLoginPath() {
  const intended = `${window.location.pathname || ''}${window.location.search || ''}`;
  const safe = getSafeInternalPath(intended);
  if (!safe) return '/user/login';
  return `/user/login?next=${encodeURIComponent(safe)}`;
}

// Handle invalid token in the response
mernDashApi.interceptors.response.use(
  (response) => response, // pass through valid responses
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token is invalid or expired
      const currentPath = window.location.pathname;

      if (!currentPath.startsWith('/user/')) {
        localStorage.removeItem('mern_admin_dashboard');
        const loginPath = buildLoginPath();
        const navigate = getNavigate();
        if (navigate) {
          navigate(loginPath);
        } else {
          window.location.href = loginPath;
        }
      }
    }
    return Promise.reject(error); // still return the error to calling code
  }
);

export default mernDashApi;
